import React, { useEffect, useState } from 'react';
import getDiscountAmountByProduct from '../../resolvers/getDiscountAmountByProduct';
import getDiscountDaysByProduct from '../../resolvers/getDiscountDaysByProduct';
import moment from 'moment';

export default function TableDiscount({
    currency,
    product,
    services,
    productCurrentProductId,
    setSubtitle,
}) {
    const DISCOUNT_TEXT_DEFAULT = 'Discount for unused balance by the current license.';
    const [discountCost, setDiscountCost] = useState('-');
    const discountDays = getDiscountDaysByProduct(product)
        ? getDiscountDaysByProduct(product) + ' days'
        : '';
    const sign = <span dangerouslySetInnerHTML={{ __html: currency?.sign }}></span>;
    const [licenseValidTill, setLicenseValidTill] = useState('');
    const [discountText, setDiscountText] = useState(DISCOUNT_TEXT_DEFAULT);

    const setSubtitleText = (text) => {
        if (typeof setSubtitle === 'function') {
            setSubtitle(text);
        }
    };

    useEffect(() => {
        setLicenseValidTill(moment(product?.valid_till).format('MMM DD YYYY'));
    }, [product?.valid_till]);

    useEffect(() => {
        let subtitle = '';
        const text = productCurrentProductId === 6 ? 'URLs' : 'sites';
        if (licenseValidTill && services && services > 0 && productCurrentProductId != 7) {
            if (product?.extra_package) {
                subtitle = `Current license is valid till ${licenseValidTill} and including up to ${
                    services === 0 ? 'unlimited' : services
                } ${text} with Extra package.`;
                setDiscountText(`<i class="color--grey-4"> ${subtitle}</i>`);
            } else {
                setDiscountText(
                    `<p class="bold mb-7">Discount for unused balance on the current package</p>` +
                        `<i class="color--grey-4">Current license is valid till ${licenseValidTill} and including up to ${
                            services === 0 ? 'unlimited' : services
                        } ${text}</i>`
                );
            }
        } else if (licenseValidTill) {
            subtitle = `Current license is valid till ${licenseValidTill} and including up to ${
                services === 0 ? 'unlimited' : services
            } ${text}.`;
            setDiscountText(`<i class="color--grey-4"> ${subtitle}</i>`);
        } else {
            setDiscountText(DISCOUNT_TEXT_DEFAULT);
        }
        setSubtitleText(subtitle);
    }, [product?.valid_till, product?.tariff?.services, licenseValidTill]);

    useEffect(() => {
        setDiscountCost(
            <>
                {sign}
                {Number(getDiscountAmountByProduct(product) * currency?.rate).toFixed(2)}
            </>
        );
    }, [currency]);

    // DB API has a different discounts UI.
    if (product?.product_id === 2 && product?.bonus_amount > 0) {
        return (
            <div className={'section__row section__row--extra'}>
                <div className={'section__cell section__cell--name'}>
                    <p className={'text bold'}>
                        <span className={'color--blue-2'}>
                            {product?.bonus_amount} {product?.units ?? 'checks'}
                        </span>{' '}
                        available as bonus from previous license
                    </p>
                </div>
                <div
                    className={
                        'section__cell section__cell--sites tablet-pt-7 tablet-pb-7 hide-tablet'
                    }
                ></div>
                <div
                    className={
                        'section__cell section__cell--per-site tablet-pt-7 tablet-pb-7 hide-tablet'
                    }
                ></div>
                <div className={'section__cell section__cell--sum tablet-pt-7'}></div>
            </div>
        );
    }

    return (
        <div className={'section__row section__row--extra'}>
            <div className={'section__cell section__cell--name'}>
                <div className={'text'}>
                    <span dangerouslySetInnerHTML={{ __html: discountText }}></span>
                    <i className={'color--grey-4'}>&nbsp;({discountDays})</i>
                </div>
            </div>
            <div className={'section__cell section__cell--sites hide-tablet'}></div>
            <div className={'section__cell section__cell--per-site hide-tablet'}></div>
            <div className={'section__cell section__cell--sum tablet-pt-7 tablet-mb-13 color--green'}>
                <span>(save {discountCost})</span>
            </div>
        </div>
    );
}
